import styled from "styled-components";
import {
	TABLET_BP,
	MOBILE_L_BP,
	FONT_WT_LIGHT,
	FONT_WT_MEDIUM,
	COLOR_TEXT_PRIMARY_B2C,
} from "@website-builder/utilities-index";

export const ContactUsWrapper = styled.div``;

export const ContactBannerWrapper = styled.div`
	height: 500px !important;
	@media only screen and (max-width: ${TABLET_BP}px) {
		height: 535px;
	}
	@media only screen and (max-width: ${MOBILE_L_BP}px) {
		background-position: 65% center !important;
	}
	width: 100%;
	overflow-y: hidden;
	background: ${(props) => props.backgroundStyle};
	background-repeat: no-repeat !important;
	background-size: cover !important;
	background-position: center center !important;
	.hero-content-container {
		height: 100%;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		h1,
		p {
			color: white;
			text-align: center;
		}
	}
	.banner-text-shadow {
		div,
		p,
		h1 {
			text-shadow: 0 2px 7px rgba(72, 72, 94, 0.5);
		}
	}
	h1 {
		margin-bottom: 3 0px;
		font-size: 40px;
		line-height: 1.31;
		margin-top: 20px;
		font-weight: ${FONT_WT_MEDIUM};
	}
	p {
		margin: 0 0 10px;
		line-height: 27px;
		font-weight: ${FONT_WT_LIGHT};
	}
`;
